import { z } from 'zod';
import { DeliveryPrice, DeliveryPriceSchema } from '@/types/delivery-price/delivery-price.type.ts';
import { PaginationMeta, PaginationMetaSchema } from '@/types/pagination-meta.ts';

export type DeliveryPricesPaginator = {
    data: DeliveryPrice[],
    meta: PaginationMeta,
};

export type DeliveryPricesRequestFilter = {
    page?: number,
    brand_id?: number,
    model_id?: number[],
    city_from_id?: number[],
    city_to_id?: number[],
    is_active?: 0 | 1,
    price?: number,
    sort?: Record<string, string>[],
};

export const DeliveryPricesPaginatorSchema = z.object({
    data: z.array(DeliveryPriceSchema),
    meta: PaginationMetaSchema,
});
